import { useCallback, useMemo } from 'react';
import styled from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { addHandholdingBannerParamsToLink } from '../utils/urls';
import { trackUserInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Card = styled.article.withConfig({
  displayName: "NextActionModalCard__Card"
})(({
  theme,
  $hasIllustration: hasIllustration
}) => `
  background-color: ${theme.color['fill-surface-default']};
  border-color: ${theme.color['border-core-subtle']};
  border-radius: ${theme.borderRadius['transitional-floating']};
  border-width: ${theme.borderWidth[100]};
  border-style: solid;
  box-shadow: ${theme.boxShadow[200]};
  padding: ${theme.space[600]};

  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${theme.space[600]};
  grid-template-areas: ${hasIllustration ? "'content illustration' 'button illustration'" : "'content button'"};
`);
const FlexWithTemplateArea = styled.div.withConfig({
  displayName: "NextActionModalCard__FlexWithTemplateArea"
})(({
  theme
}) => `
  display: flex;
  gap: ${theme.space[300]};
  flex-direction: column;
  justify-content: center;
  align-items: start;

  grid-area: content;
`);
export const NextActionModalCard = ({
  title,
  description,
  button,
  illustration: illustrationProps,
  trackingProperties = {},
  handholdingBanner
}) => {
  const handleButtonClick = useCallback((...args) => {
    var _button$onClick;
    (_button$onClick = button.onClick) === null || _button$onClick === void 0 || _button$onClick.call(button, ...args);
    trackUserInteraction('next action modal', 'click card button', trackingProperties);
  }, [trackingProperties, button]);
  const hrefWithHandholdingBannerParams = useMemo(() => addHandholdingBannerParamsToLink(button.href, handholdingBanner), [button.href, handholdingBanner]);
  return /*#__PURE__*/_jsxs(Card, {
    $hasIllustration: Boolean(illustrationProps),
    children: [/*#__PURE__*/_jsxs(FlexWithTemplateArea, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-200",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-subtle",
        children: description
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        gridArea: 'button',
        alignSelf: 'center'
      },
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "next-action-modal-card-button",
        use: "primary",
        onClick: handleButtonClick,
        href: hrefWithHandholdingBannerParams,
        target: button.target,
        children: button.text
      })
    }), illustrationProps && /*#__PURE__*/_jsx("div", {
      style: {
        gridArea: 'illustration',
        alignSelf: 'center'
      },
      children: /*#__PURE__*/_jsx(Illustration, Object.assign({}, illustrationProps, {
        width: illustrationProps.width || 110
      }))
    })]
  });
};